var BaseCollection = require('./base-collection');


var DboTypesCollection = BaseCollection.extend({

    url:"/api/relationtype/dbotypes",

    initialize: function(models, options){
        BaseCollection.prototype.initialize.apply(this, arguments);
    },

    parse: function(response) {
        var transformed = response.map(function(item) {
            return {'name': item};
        });
        return transformed;
    }
});


module.exports = DboTypesCollection;


//////////////////
// WEBPACK FOOTER
// ./app/collections/dbotypes-collection.js
// module id = 430
// module chunks = 0